import React from "react";
// import MultiLineText from './MultiLineText';
import { assetsPath } from "../../../../utils";

const baseAssetUrl = assetsPath("phuket-dusit-deluxe-pool-villa");

export default ({ currentLang, selectedType, width, height }) => {
  const map = `${baseAssetUrl}/images/site-plan/${currentLang}/map.jpg`;
  const twoBed = `${baseAssetUrl}/images/site-plan/two-bedroom.png`;
  const threeBed = `${baseAssetUrl}/images/site-plan/three-bedroom.png`;
  // console.log('selectedType', selectedType);

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      viewBox={`0 0 ${width} ${height}`}
      className="site-plan-svg"
    >
      <image xlinkHref={map} x={0} y={0} width={width} height={height} />
      <image
        xlinkHref={twoBed}
        x={0}
        y={0}
        width={width}
        height={height}
        className={`${
          selectedType === "two-bedroom" || selectedType === "all"
            ? "flim-out"
            : "flim-in"
        }`}
      />
      <image
        xlinkHref={threeBed}
        x={0}
        y={0}
        width={width}
        height={height}
        className={`${
          selectedType === "three-bedroom" || selectedType === "all"
            ? "flim-out"
            : "flim-in"
        }`}
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketDusitDeluxePoolVilla/sitePlan/svg/index.js